import { Provider } from './Provider';
export class PageProvider extends Provider {
    sourcePage = null;
    mediumPage = null;
    campaignPage = null;
    conversionPixelsPage = null;
    constructor() {
        super();
        this.setAttributionByPageValues();
    }
    setAttributionByPageValues() {
        if (typeof window.page.tracking === 'undefined') {
            return;
        }
        if (typeof window.page.tracking.source !== 'undefined' &&
            typeof window.page.tracking.medium !== 'undefined' &&
            typeof window.page.tracking.campaign !== 'undefined' &&
            (window.page.tracking.source !== '' ||
                window.page.tracking.medium !== '' ||
                window.page.tracking.campaign !== '')) {
            this.sourcePage = window.page.tracking.source || 'undefined';
            this.mediumPage = window.page.tracking.medium || 'undefined';
            this.campaignPage = window.page.tracking.campaign || 'undefined';
        }
        if (typeof window.page.tracking.conversionPixels === 'string') {
            const pixels = window.page.tracking.conversionPixels.trim().replaceAll('\r\n', '\n').split('\n');
            if (pixels.length > 0) {
                this.conversionPixelsPage = pixels.map((pixel) => pixel.trim());
            }
        }
    }
    get source() {
        return this.sourcePage;
    }
    get medium() {
        return this.mediumPage;
    }
    get campaign() {
        return this.campaignPage;
    }
    get pageProduct() {
        return window.page.product;
    }
    get pageLocation() {
        return window.page.location || null;
    }
    get conversionPixels() {
        return this.conversionPixelsPage;
    }
    get originDetails() {
        const originD = {};
        originD['page_type'] =
            typeof window.page === 'object' && typeof window.page.type === 'string' ? window.page.type : '';
        originD['page_version'] =
            typeof window.page === 'object' && typeof window.page.version === 'string' ? window.page.version : '';
        originD['page_chatType'] =
            typeof window.page === 'object' && typeof window.page.chatType === 'string' ? window.page.chatType : '';
        originD['page_product'] =
            typeof window.page.product === 'object' && typeof window.page.product !== 'undefined'
                ? window.page.product
                : '';
        return originD;
    }
}
